/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'

import {
  PageContainer,
  ButtonWrapper,
  Button,
  PageText,
  Spacing,
  BottomSheet,
  UIFlex,
  UIButton,
} from 'components'
import { IPosAberturaCtx } from 'interfaces/posAbertura.interface'
import { FichaCadastralCtx, GlobalAccountCtx, PosAberturaCtx } from 'App'
import { useHistory } from 'react-router-dom'
import { sendDataNative, TSendDataNative } from 'components/hooks/useFetchNative'
import { DESCRIPTION_SHARE_FRIENDS } from 'shared/functions/constants'
import { IShare } from 'interfaces/share.interface'
import { sendToNewRelic } from 'services'
import { IFichaCadastralCtx } from 'interfaces/fichaCadastral.interface'
import { RoutesEnum } from 'enums/routes.enum'
import url from 'shared/functions/url'
import { Icons } from 'components'
import { CheckCircle, CloseCircle } from 'components/elements/Icons'
import { GAParamsEnum } from 'enums/gaParams'
import { putContaGlobal } from 'services/axios'
import { IGlobalAccountCtx } from 'interfaces/globalAccount.interface'
import { putInteresseKids } from 'services/axios/putKidsInterest'
import { verifyVersions } from 'utils/version'

import { Text } from '@inter/inter-ui'

import { ListItens } from './listInfo'
import * as S from './styles'

const LIST_OPTIONS = {
  '/conta-mei': 'CONTA_MEI',
  '/conta-global': 'CONTA_GLOBAL',
  '/indicar-amigos': 'INDICAR_AMIGOS',
  '/inter-loop': 'INTER_LOOP',
  '/interesse-kids': 'INTERESSE_KIDS',
}

const VERSION_CURRENT = '14.3.0'

type THomeAdult = {
  version: string
}

const MESSAGEM = {
  global: {
    message:
      ' Em breve entraremos em contato informando os próximos passos para abertura da sua Conta Global.',
  },
  kids: {
    message:
      'Em breve entraremos em contato informando os próximos passos para abertura da Conta Kids.',
  },
  error: {
    message: 'No momento, não é possível concluir a ação. Você pode tentar novamente mais tarde.',
  },
}

const HomeAdult = ({ version }: THomeAdult) => {
  const { posAberturaOptions, setPosAberturaOptions }: IPosAberturaCtx =
    useContext<IPosAberturaCtx>(PosAberturaCtx)
  const { globalAccount } = useContext<IGlobalAccountCtx>(GlobalAccountCtx)
  const [loadingLead, setLoadingLead] = useState(false)
  const [bottomSheet, setBottomSheet] = useState<string | null>(null)

  const history = useHistory()
  const { isMinor } = url.queryParam()

  const { hsfc }: IFichaCadastralCtx = useContext<IFichaCadastralCtx>(FichaCadastralCtx)
  const hsfcValue = (): string => hsfc || (sessionStorage.getItem('hsfc') as string)

  const indicarAmigos = () => {
    const callApi: TSendDataNative<IShare> = {
      callback: 'callbackIndicarAmigos',
      body: { description: DESCRIPTION_SHARE_FRIENDS },
      endpoint: '',
      method: 'SHARE',
    }
    sendDataNative(callApi)
  }

  const handleFinalizarAbertura = () => {
    history.push(RoutesEnum.FIM_ONBOARDING)

    sendToNewRelic('POS_ABERTURA', `[CLIK] - Continuar`, {
      FICHA_CADASTRAL: hsfcValue(),
      PRODUCT: 'CONTA_DIGITAL',
      MINOR: isMinor ? 'KIDS' : 'PF',
    })
  }

  const handleItemClick = (link: string) => {
    sendToNewRelic('POS_ABERTURA', `[CLIK] - ${LIST_OPTIONS[link]}`, {
      FICHA_CADASTRAL: hsfcValue(),
      PRODUCT: 'CONTA_DIGITAL',
      MINOR: isMinor ? 'KIDS' : 'PF',
    })

    if (link === 'INDICAR_AMIGOS') {
      indicarAmigos()
    } else if (
      globalAccount === GAParamsEnum.GLOBAL_ACCOUNT_INTEREST &&
      link === RoutesEnum.CONTA_GLOBAL
    ) {
      handleConfirmLeadGA()
    } else if (link === RoutesEnum.INTERESSE_KIDS) {
      handleClickLeadKids()
    } else {
      history.push(link)
    }
  }

  useEffect(() => {
    sendToNewRelic('POS_ABERTURA', '[Screen] - TUDO CERTO', {
      FICHA_CADASTRAL: hsfcValue(),
      PRODUCT: 'CONTA_DIGITAL',
      MINOR: isMinor ? 'KIDS' : 'PF',
      GA_PARAMS: globalAccount,
    })
  }, [])

  useEffect(() => {
    if (globalAccount === GAParamsEnum.GLOBAL_ACCOUNT_HIDDEN) {
      setPosAberturaOptions({
        ...posAberturaOptions,
        global: { ...posAberturaOptions.global, display: false },
      })
    }
  }, [globalAccount, posAberturaOptions])

  useEffect(() => {
    if (verifyVersions(version, VERSION_CURRENT)) {
      setPosAberturaOptions({
        ...posAberturaOptions,
        kids: { ...posAberturaOptions.kids, display: true },
      })
    }
  }, [])

  const handleConfirmLeadGA = () => {
    setLoadingLead(true)
    sendToNewRelic('POS_ABERTURA', 'ContaGlobal - Sucesso', {
      FICHA_CADASTRAL: hsfcValue(),
      laedGA: true,
    })

    putContaGlobal({
      data: {
        criaContaGlobal: false,
        interesseContaGlobal: true,
      },
      header: {
        hsfc: hsfcValue(),
      },
      success: () => {
        setBottomSheet('global')
        setPosAberturaOptions({
          ...posAberturaOptions,
          global: { ...posAberturaOptions.global, done: true },
        })
        sendToNewRelic('POS_ABERTURA', 'ContaGlobal - Sucesso', {
          FICHA_CADASTRAL: hsfcValue(),
        })
      },
      error: (error) => {
        setBottomSheet('error')
        sendToNewRelic('POS_ABERTURA', 'ContaGlobal - Error', {
          FICHA_CADASTRAL: hsfcValue(),
          response: JSON.stringify(error),
        })
      },
      finally: () => {
        setLoadingLead(false)
      },
    })
  }

  const handleClickLeadKids = () => {
    setLoadingLead(true)

    putInteresseKids({
      data: {
        interesseContaKids: true,
      },
      header: {
        hsfc: hsfcValue(),
      },
      success: () => {
        setBottomSheet('kids')
        setPosAberturaOptions({
          ...posAberturaOptions,
          kids: { ...posAberturaOptions.kids, done: true },
        })
        sendToNewRelic('POS_ABERTURA', 'Lead Kids - Sucesso', {
          FICHA_CADASTRAL: hsfcValue(),
          leadKids: true,
        })
      },
      error: (error) => {
        setBottomSheet('error')
        sendToNewRelic('POS_ABERTURA', 'Lead Kids - Error', {
          FICHA_CADASTRAL: hsfcValue(),
          response: JSON.stringify(error),
        })
      },
      finally: () => {
        setLoadingLead(false)
      },
    })
  }

  return (
    <PageContainer>
      <PageText text="Que tal aproveitar todo o potencial do Inter?" margin="80px 0px 16px 0px" />

      <Spacing mb="lg">
        <Text variant="body-3">
          Tenha diversas modalidades de conta e aproveite um universo de oportunidades!
        </Text>
      </Spacing>

      <ListItens items={posAberturaOptions} onClick={handleItemClick} />

      <ButtonWrapper>
        <Button onClick={handleFinalizarAbertura} isLoading={loadingLead} disabled={loadingLead}>
          Continuar
        </Button>
      </ButtonWrapper>

      {!!bottomSheet && (
        <BottomSheet onClose={() => setBottomSheet(null)}>
          <UIFlex direction="column" alignItems="center" gap="8x">
            <S.GreenCircle color={bottomSheet}>
              <Icons
                variant={bottomSheet === 'error' ? CloseCircle : CheckCircle}
                color="#ffffff"
              />
            </S.GreenCircle>
            <Spacing mt="xs">
              <Text variant="headline-h3">
                {bottomSheet === 'error' ? 'Houve um erro por aqui' : 'Interesse registrado'}
              </Text>
            </Spacing>
            <Text variant="body-3" style={{ textAlign: 'center' }}>
              {MESSAGEM[bottomSheet].message}
            </Text>
            <Spacing mt="xs" style={{ width: '100%' }}>
              <UIButton fullWidth onClick={() => setBottomSheet(null)}>
                Entendi
              </UIButton>
            </Spacing>
          </UIFlex>
        </BottomSheet>
      )}
    </PageContainer>
  )
}

export default HomeAdult
